import SellerDashboard from "../containers/Dashboard";

import Orders from "@containers/Admin/Sales/Orders/Loadable";

import Items from "@containers/Admin/Sales/Items/Loadable";

import BrandSectionAddEdit from "@containers/ContentSection/BrandSection/AddEdit/Loadable";
import BrandSection from "@containers/ContentSection/BrandSection/Loadable";

import ContentSectionAddEdit from "@containers/ContentSection/ContentSection/AddEdit/Loadable";
import ContentSection from "@containers/ContentSection/ContentSection/Loadable";

import SliderSectionAddEdit from "@containers/ContentSection/SliderSection/AddEdit/Loadable";
import SliderSection from "@containers/ContentSection/SliderSection/Loadable";

import ProductAddEdit from "@containers/Admin/Catalog/Products/AddEdit/Loadable";
import ProductsManage from "@containers/Admin/Catalog/Products/Loadable";

import BrandAddEdit from "@containers/Admin/Catalog/BrandManage/AddEdit/Loadable";
import BrandManage from "@containers/Admin/Catalog/BrandManage/Loadable";

import UsersAddEditManage from "@containers/Admin/Users/AddEdit/Loadable";
import UserManage from "@containers/Admin/Users/Loadable";

import EditorFileSelect from "@containers/Admin/EditorFileSelect/Loadable";

import PageManageAddEdit from "@containers/Admin/PageManage/AddEdit/Loadable";
import PageManage from "@containers/Admin/PageManage/Loadable";

// import ProductCustomAttributeAddEdit from "@containers/Admin/Catalog/ProductCustomManage/AddEdit/Loadable";
// import ProductCustomAttribute from "@containers/Admin/Catalog/ProductCustomManage/Loadable";

import HomePageGroups from "@containers/Admin/HomePageGroups/Loadable";

import MenuSectionAddEdit from "@containers/ContentSection/MenuSection/AddEdit/Loadable";
import MenuSection from "@containers/ContentSection/MenuSection/Loadable";

import QuestionsManage from "@containers/Admin/QuestionsManage/Loadable";

import CouponManageAddEdit from "@containers/Marketing/CouponsManage/AddEdit/Loadable";
import CouponsManage from "@containers/Marketing/CouponsManage/Loadable";

import ReturnCompleted from "@containers/Admin/ReturnsManage/ReturnCompleted/Loadable";
import ReturnRequest from "@containers/Admin/ReturnsManage/ReturnRequest/Loadable";

import BlogManageAddEdit from "@containers/Admin/BlogManage/AddEdit/Loadable";
import BlogManage from "@containers/Admin/BlogManage/Loadable";

import BlogsCatAddEdit from "@containers/Admin/BlogCategoryManage/AddEdit/Loadable";
import BlogsCategoryManage from "@containers/Admin/BlogCategoryManage/Loadable";

import PickupLocation from "@containers/Admin/Shipping/PickupLocation";
import PickupLocationAddEditPage from "@containers/Admin/Shipping/PickupLocation/PickupLocationAddEditPage";

import ShippingCharge from "@containers/Admin/Shipping/ShippingCharge";
import ShippingChargeAddEditPage from "@containers/Admin/Shipping/ShippingCharge/ShippingChargeAddEditPage";

import TreeView from "@containers/Admin/Locations/TreeView/Loadable";

import StateAddEditPage from "@containers/Admin/Locations/State/AddEdit/Loadable";
import State from "@containers/Admin/Locations/State/Loadable";

import DistrictAddEditPage from "@containers/Admin/Locations/District/AddEdit/Loadable";
import District from "@containers/Admin/Locations/District/Loadable";

import MunicipalityAddEditPage from "@containers/Admin/Locations/Municipality/AddEdit/Loadable";
import Municipality from "@containers/Admin/Locations/Municipality/Loadable";

// import AreaAddEditPage from "@containers/Admin/Locations/Area/AddEdit/Loadable";
// import Area from "@containers/Admin/Locations/Area/Loadable";

import ReviewManage from "@containers/Admin/ReviewManage/Loadable";

import ShippingPartner from "@containers/Admin/Shipping/ShippingPartner";
import ShippingPartnerAddEdit from "@containers/Admin/Shipping/ShippingPartner/AddEdit/ShippingPartnerAddEdit";

import SmsList from "@containers/Admin/Sms";

import ModuleManage from "@containers/Admin/Module/Loadable";
import ModuleAddEdit from "@containers/Admin/Module/AddEdit";
import ModuleAccessManage from "@containers/Admin/Module/AddEdit/components/AccessManage";

import ModuleGroupManage from "@containers/Admin/ModuleGroup/Loadable";
import ModuleGroupAddEdit from "@containers/Admin/ModuleGroup/AddEdit/Loadable";

import Roles from "@containers/Admin/Roles/Loadable";
import RolesAddEdit from "@containers/Admin/Roles/AddEdit";
import OfficeManage from "@containers/Admin/OfficeManage/Loadable";
import OfficeManageAddEdit from "@containers/Admin/OfficeManage/AddEdit/Loadable";

import SchemeManage from "@containers/Admin/SchemeManage/Loadable";
import SchemeManageAddEdit from "@containers/Admin/SchemeManage/AddEdit/Loadable";

import CampaignManage from "@containers/Admin/CampaignManage/Loadable";
import CampaignManageAddEdit from "@containers/Admin/CampaignManage/AddEdit/Loadable";

import OrderManage from "@containers/Admin/OrderManage/Loadable";
import OrderManageDetails from "@containers/Admin/OrderManage/Detail/Loadable";
import OrderDetailAdd from "@containers/Admin/OrderManage/Add/Loadable";

import HandraiserManage from "@containers/Admin/HandraiserManage/Loadable";
import HandraiserDetail from "@containers/Admin/HandraiserManage/Detail/Loadable";

import OrderReports from "@containers/Admin/Reports/OrderReports/Loadable";
import HandraiserReports from "@containers/Admin/Reports/HandraiserReports/Loadable";
import ClientErrors from "@containers/Admin/Errors/ClientErrors";
import ServerErrors from "@containers/Admin/Errors/ServerErrors/Loadable";
import GlobalSettings from "@containers/Admin/GlobalSettings";
import GlobalSettingsManage from "@containers/Admin/GlobalSettings/Loadable";
import GlobalSettingsAddEdit from "@containers/Admin/GlobalSettings/AddEdit/Loadable";
import ProductSection from "@containers/ContentSection/OfferSection/Loadable";
import ProductSectionAddEdit from "@containers/ContentSection/OfferSection/AddEdit/Loadable";
import MainFieldManage from "@containers/Admin/MainFieldManage";
import MainFieldManageAddEdit from "@containers/Admin/MainFieldManage/AddEdit";
import CampaignAllowAccess from "@containers/Admin/CampaignManage/AllowAccess";

export const AdminRoutes = [
  {
    path: "dashboard/commerce",
    element: <SellerDashboard />,
  },
  {
    path: "coupon-manage",
    element: <CouponsManage />,
  },
  {
    path: "coupon-manage/add",
    element: <CouponManageAddEdit />,
  },
  {
    path: "coupon-manage/edit/:id",
    element: <CouponManageAddEdit />,
  },

  {
    path: "orders",
    element: <Orders />,
  },
  {
    path: "user-manage",
    element: <UserManage />,
  },
  {
    path: "user-manage/add",
    element: <UsersAddEditManage />,
  },
  {
    path: "location-tree-view",
    element: <TreeView />,
  },
  {
    path: "state-manage",
    element: <State />,
  },
  {
    path: "state-manage/add",
    element: <StateAddEditPage />,
  },
  {
    path: "state-manage/edit/:id",
    element: <StateAddEditPage />,
  },
  {
    path: "district-manage",
    element: <District />,
  },
  {
    path: "district-manage/add",
    element: <DistrictAddEditPage />,
  },
  {
    path: "district-manage/edit/:id",
    element: <DistrictAddEditPage />,
  },
  {
    path: "area-manage",
    element: <Municipality />,
  },
  {
    path: "area-manage/add",
    element: <MunicipalityAddEditPage />,
  },
  {
    path: "area-manage/edit/:id",
    element: <MunicipalityAddEditPage />,
  },
  // {
  //   path: "area-manage",
  //   element: <Area />,
  // },
  // {
  //   path: "area-manage/add",
  //   element: <AreaAddEditPage />,
  // },
  // {
  //   path: "area-manage/edit/:id",
  //   element: <AreaAddEditPage />,
  // },
  {
    path: "pickup",
    element: <PickupLocation />,
  },
  {
    path: "pickup/add",
    element: <PickupLocationAddEditPage />,
  },
  {
    path: "pickup/edit/:id",
    element: <PickupLocationAddEditPage />,
  },
  {
    path: "shipping-charge",
    element: <ShippingCharge />,
  },
  {
    path: "shipping-charge/add",
    element: <ShippingChargeAddEditPage />,
  },
  {
    path: "shipping-charge/edit/:id",
    element: <ShippingChargeAddEditPage />,
  },
  {
    path: "active-orders",
    element: <Items />,
  },
  {
    path: "archived-items",
    element: <Items />,
  },
  {
    path: "archived-orders",
    element: <Orders />,
  },
  {
    path: "product-section",
    element: <ProductSection />,
  },
  {
    path: "product-section/add",
    element: <ProductSectionAddEdit />,
  },
  {
    path: "product-section/edit/:id",
    element: <ProductSectionAddEdit />,
  },
  {
    path: "brand-section-manage",
    element: <BrandSection />,
  },
  {
    path: "brand-section-manage/add",
    element: <BrandSectionAddEdit />,
  },
  {
    path: "brand-section-manage/edit/:id",
    element: <BrandSectionAddEdit />,
  },
  {
    path: "content-manage",
    element: <ContentSection />,
  },
  {
    path: "content-manage/add",
    element: <ContentSectionAddEdit />,
  },
  {
    path: "content-manage/edit/:id",
    element: <ContentSectionAddEdit />,
  },
  {
    path: "slider-manage",
    element: <SliderSection />,
  },
  {
    path: "slider-manage/add",
    element: <SliderSectionAddEdit />,
  },
  {
    path: "slider-manage/edit/:id",
    element: <SliderSectionAddEdit />,
  },
  {
    path: "product-manage/:type",
    element: <ProductsManage />,
  },
  {
    path: "product-manage/:type/add",
    element: <ProductAddEdit />,
  },
  {
    path: "product-manage/:type/edit/:id",
    element: <ProductAddEdit />,
  },
  {
    path: "brand-manage",
    element: <BrandManage />,
  },
  {
    path: "brand-manage/add",
    element: <BrandAddEdit />,
  },
  {
    path: "brand-manage/edit/:id",
    element: <BrandAddEdit />,
  },
  {
    path: "media-manage",
    element: <EditorFileSelect />,
  },
  {
    path: "page-manage",
    element: <PageManage />,
  },
  {
    path: "page-manage/add",
    element: <PageManageAddEdit />,
  },
  {
    path: "page-manage/edit/:id",
    element: <PageManageAddEdit />,
  },
  {
    path: "coupon-manage",
    element: <CouponsManage />,
  },
  {
    path: "coupon-manage/add",
    element: <CouponManageAddEdit />,
  },
  {
    path: "home-page-groups",
    element: <HomePageGroups />,
  },
  {
    path: "home-page-groups/edit/:id",
    element: <HomePageGroups />,
  },
  {
    path: "menu-manage",
    element: <MenuSection />,
  },
  {
    path: "menu-manage/add",
    element: <MenuSectionAddEdit />,
  },
  {
    path: "menu-manage/edit/:id",
    element: <MenuSectionAddEdit />,
  },
  {
    path: "asked-questions",
    element: <QuestionsManage />,
  },
  {
    path: "return-requests",
    element: <ReturnRequest />,
  },
  {
    path: "return-completed",
    element: <ReturnCompleted />,
  },
  {
    path: "blog-manage",
    element: <BlogManage />,
  },
  {
    path: "blog-manage/add",
    element: <BlogManageAddEdit />,
  },
  {
    path: "blog-manage/edit/:id",
    element: <BlogManageAddEdit />,
  },
  {
    path: "blog-cat-manage",
    element: <BlogsCategoryManage />,
  },
  {
    path: "blog-cat-manage/add",
    element: <BlogsCatAddEdit />,
  },
  {
    path: "blog-cat-manage/edit/:id",
    element: <BlogsCatAddEdit />,
  },
  {
    path: "sms-list",
    element: <SmsList />,
  },
  {
    path: "review-manage",
    element: <ReviewManage />,
  },
  {
    path: "shipping-partner",
    element: <ShippingPartner />,
  },
  {
    path: "shipping-partner/add",
    element: <ShippingPartnerAddEdit />,
  },
  {
    path: "shipping-partner/edit/:id",
    element: <ShippingPartnerAddEdit />,
  },
  {
    path: "module-manage",
    element: <ModuleManage />,
  },
  {
    path: "module-manage/add",
    element: <ModuleAddEdit />,
  },
  {
    path: "module-manage/edit/:id",
    element: <ModuleAddEdit />,
  },
  {
    path: "module-manage/access/:id",
    element: <ModuleAccessManage />,
  },
  {
    path: "sub-modules",
    element: <ModuleGroupManage />,
  },
  {
    path: "sub-modules/add",
    element: <ModuleGroupAddEdit />,
  },
  {
    path: "sub-modules/edit/:id",
    element: <ModuleGroupAddEdit />,
  },
  {
    path: "role-manage",
    element: <Roles />,
  },
  {
    path: "role-manage/add",
    element: <RolesAddEdit />,
  },
  {
    path: "role-manage/edit/:id",
    element: <RolesAddEdit />,
  },
  {
    path: "office-manage/:type",
    element: <OfficeManage />,
  },
  {
    path: "office-manage/:type/add",
    element: <OfficeManageAddEdit />,
  },
  {
    path: "office-manage/:type/edit/:id",
    element: <OfficeManageAddEdit />,
  },

  { path: "scheme-manage/data-campaign", element: <CampaignManage /> },
  {
    path: "scheme-manage/data-campaign/add",
    element: <CampaignManageAddEdit />,
  },
  {
    path: "scheme-manage/data-campaign/edit/:id",
    element: <CampaignManageAddEdit />,
  },
  {
    path: "scheme-manage/data-campaign/access/:id",
    element: <CampaignAllowAccess />,
  },
  { path: "scheme-manage/:scheme_type", element: <SchemeManage /> },
  {
    path: "scheme-manage/:scheme_type/add",
    element: <SchemeManageAddEdit />,
  },
  {
    path: "scheme-manage/:scheme_type/edit/:id",
    element: <SchemeManageAddEdit />,
  },
  {
    path: "scheme-manage/:scheme_type/duplicate/:id",
    element: <SchemeManageAddEdit />,
  },
  {
    path: "order-manage/:order_type",
    element: <OrderManage />,
  },
  {
    path: "order-manage/:order_type/detail/:id",
    element: <OrderManageDetails />,
  },
  {
    path: "order-manage/:order_type/add",
    element: <OrderDetailAdd />,
  },
  {
    path: "handraiser-manage",
    element: <HandraiserManage />,
  },
  {
    path: "handraiser-manage/detail/:id",
    element: <HandraiserDetail />,
  },
  {
    path: "order-report/:type",
    element: <OrderReports />,
  },
  {
    path: "handraiser-report",
    element: <HandraiserReports />,
  },

  {
    path: "client-errors",
    element: <ClientErrors />,
  },

  {
    path: "server-errors",
    element: <ServerErrors />,
  },

  {
    path: "global-setting",
    element: <GlobalSettingsManage />,
  },

  {
    path: "global-setting/add",
    element: <GlobalSettingsAddEdit />,
  },
  {
    path: "global-setting/edit/:id",
    element: <GlobalSettingsAddEdit />,
  },

  {
    path: "scheme-manage/main-field",
    element: <MainFieldManage />,
  },
  {
    path: "scheme-manage/main-field/add",
    element: <MainFieldManageAddEdit />,
  },
  {
    path: "scheme-manage/main-field/edit/:id",
    element: <MainFieldManageAddEdit />,
  },
];
